import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/navbar.ms.options.vehicle.module.scss';
import mobileStyles from './styles/navbar.ms.options.vehicle.mobile.module.scss';
import {
  capitalize,
  convertToNZDate,
  convertToNZShortDate,
  getAge,
  prettifyNumber,
} from 'helpers';
import {
  SetUpdateMarketScanPopup,
  SetPolicyDetailsSection,
} from 'actions/navbar-actions';
import { IAppState, IPolicyScan } from 'types';
import editIcon from 'assets/icons/edit.svg';
import classNames from 'classnames';

interface IProps {
  policyScan: IPolicyScan;
}

const NavBarMarketScanOptionsLife = ({ policyScan }: IProps) => {
  const dispatch = useDispatch();

  const isDetailsPopup = useSelector(
    (state: IAppState) => state.navBar.showPolicyDetails,
  );

  const toggleDetailsPanel = useCallback(() => {
    dispatch(SetPolicyDetailsSection(!isDetailsPopup));
  }, [isDetailsPopup]);

  const openUpdatePopup = useCallback(() => {
    dispatch(SetUpdateMarketScanPopup(true));
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.section} onClick={openUpdatePopup}>
        <span className={styles.label}>Life cover amount:</span>{' '}
        <span className={styles.link}>
          {`$${prettifyNumber(policyScan.amount)}`}
        </span>
        <img src={editIcon} alt="Edit" className={styles.editIcon} />
      </div>

      {policyScan.dateOfBirth && (
        <div className={styles.section}>
          <span className={styles.label}>Date of birth:&nbsp;</span>
          <span>
            {`${convertToNZDate(policyScan.dateOfBirth)} (${getAge(
              policyScan.dateOfBirth,
            )} y.o.)`}
          </span>
        </div>
      )}

      {policyScan.employment && (
        <div className={styles.section}>
          <span className={styles.label}>Employment:&nbsp;</span>
          <span>{capitalize(policyScan.employment)}</span>
        </div>
      )}

      <div className={styles.moreInfoSection} onClick={toggleDetailsPanel}>
        <span className={classNames(styles.link, styles.moreInfoText)}>
          {isDetailsPopup ? 'Less info' : 'More info'}
        </span>
      </div>
    </div>
  );
};

export const NavBarMarketScanOptionsLifeMobile = ({ policyScan }: IProps) => {
  const dispatch = useDispatch();

  const openUpdatePopup = useCallback(() => {
    dispatch(SetUpdateMarketScanPopup(true));
  }, []);

  return (
    <div
      className={classNames(
        mobileStyles.container,
        mobileStyles.life,
        'lifeMobileChips',
      )}
    >
      <div
        className={classNames(mobileStyles.section, mobileStyles.noShrink)}
        onClick={openUpdatePopup}
      >
        <span className={mobileStyles.label}>Cover:</span>{' '}
        <span className={mobileStyles.link}>
          {`$${prettifyNumber(policyScan.amount)}`}
        </span>
      </div>

      {policyScan.dateOfBirth && (
        <div
          className={classNames(mobileStyles.section, mobileStyles.noShrink)}
        >
          <span className={mobileStyles.label}>DOB:</span>{' '}
          {convertToNZShortDate(policyScan.dateOfBirth)}
        </div>
      )}

      {policyScan.employment && (
        <div
          className={classNames(mobileStyles.section, mobileStyles.truncate)}
        >
          {capitalize(policyScan.employment)}
        </div>
      )}
    </div>
  );
};

export default NavBarMarketScanOptionsLife;
